import React from "react";
import { getColor } from "../util/CC";
import { useMediaQuery } from "react-responsive";

export default function ShapeDivider(props) {

    const template = window.sitesettings.template_info;
    const ismobile = useMediaQuery({ query: '(max-width: 716px)' })    
    // Component agnostic
    const {
        name = "",
        container = true,
        data = {},
        date_changed = 0
    } = props.content;

    // Component specific
    const {
        background_colour = 0,
        background_svg_colour = 0,
        svg_style = "M321.39,56.44c58-10.79,114.16-30.13,172-41.86,82.39-16.72,168.19-17.73,250.45-.39C823.78,31,906.67,72,985.66,92.83c70.05,18.48,146.53,26.09,214.34,3V0H0V27.35A600.21,600.21,0,0,0,321.39,56.44Z",
        svg_height = 80,
        svg_width = 100,
        svg_invert = false,
        mobile_height = 80,
        allow_mobile_overrides = false,
    } = data;

    const drawRender = () => {
        const m = (allow_mobile_overrides && ismobile) ? true : false;

        return (
            <div className={(container) ? "preview-container" : ""}>
                <div style={{ "height": (m) ? `${mobile_height}px` : `${svg_height}px`, position: "relative"}}>
                    <div style={{ "background": getColor(background_colour, template), position: "absolute", top: "0", left: "0", width: "100%", overflow: "hidden", lineHeight: "0", transform: (svg_invert) ? "rotate(180deg)" : "none" }}>
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox={`0 0 1200 120`} preserveAspectRatio="none" style={{ "position": "relative", display: "block", width: `calc(${svg_width}% + 1.3px)`, height: (m) ? `${mobile_height}px` : `${svg_height}px` }}>
                            <path fill={getColor(background_svg_colour, template)} d={svg_style}>
                            </path>
                        </svg>
                    </div>
                </div>
            </div>
        )
    }

    return drawRender();
}